import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CaptionComponent } from "./caption.component";
import { IconModule } from "../icon/icon.module";
import { RouterModule } from "@angular/router";

@NgModule({
	declarations: [CaptionComponent],
	imports: [CommonModule, IconModule, RouterModule],
	exports: [CaptionComponent]
})
export class CaptionModule {}
